import { render } from "./PackageIncomeReport.vue?vue&type=template&id=12b9a5ac&ts=true&lang=pug"
import script from "./PackageIncomeReport.vue?vue&type=script&lang=ts"
export * from "./PackageIncomeReport.vue?vue&type=script&lang=ts"

import "./PackageIncomeReport.vue?vue&type=style&index=0&id=12b9a5ac&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__